import type { AutoshipCustomerApiResponse } from '@libs/common-types';

import { useAutoshipSubscriptionsQuery } from '../queries';

export type UseCustomerAutoshipSubscriptionsResult = {
    autoshipData: AutoshipCustomerApiResponse | undefined;
    isReady: boolean;
    isLoading: boolean;
    isFetching: boolean;
    isError: boolean;
};

const ONE_MINUTE = 60 * 1000;

export const useCustomerAutoshipSubscriptions = (): UseCustomerAutoshipSubscriptionsResult => {
    const {
        data: autoshipData,
        isLoading,
        isFetching,
        isError,
    } = useAutoshipSubscriptionsQuery({
        staleTime: ONE_MINUTE,
    });

    const isReady = !isLoading && !isError;

    return { autoshipData, isReady, isLoading, isFetching, isError };
};
